(function () {
  var DESKTOP_QUERY = '(min-width: 750px)';

  function initSection(section) {
    if (section.getAttribute('data-carousel-ready') === 'true') return;

    var track = section.querySelector('.stories-carousel__track');
    if (!track) return;

    var slides = Array.prototype.slice.call(section.querySelectorAll('.stories-carousel__slide'));
    if (slides.length === 0) return;

    var dashes = Array.prototype.slice.call(section.querySelectorAll('.stories-carousel__dash'));
    var prevButton = section.querySelector('.stories-carousel__arrow--prev');
    var nextButton = section.querySelector('.stories-carousel__arrow--next');

    section.setAttribute('data-carousel-ready', 'true');

    var activeIndex = 0;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayEnabled = section.getAttribute('data-autoplay') === 'true' && !reducedMotion;
    var autoplayInterval = parseInt(section.getAttribute('data-autoplay-interval'), 10) || 4500;
    var autoplayTimer = null;

    function isDesktop() {
      return window.matchMedia(DESKTOP_QUERY).matches;
    }

    function setActive(index) {
      activeIndex = index;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dashes.forEach(function (dash, i) {
        var isActive = i === index;
        dash.classList.toggle('is-active', isActive);
        dash.setAttribute('aria-selected', String(isActive));
      });
    }

    // Starts true: the IntersectionObserver's initial callback batch fires
    // asynchronously right after observe() is called, which can land after
    // setActive(0) below and report a noisy/premature reading (e.g. the
    // second slide) before any real scrolling has happened. It only flips
    // to false once an actual scroll settles, via the listener below.
    var isProgrammaticScroll = true;
    var scrollEndTimer = null;

    function goToSlide(index) {
      if (slides.length === 0) return;
      var wrapped = (index + slides.length) % slides.length;
      var slide = slides[wrapped];

      // The click/arrow/dash always knows exactly which slide it wants, so
      // mark it active right away instead of waiting for the
      // IntersectionObserver to (asynchronously, and sometimes ambiguously
      // mid-transition) figure it out on its own.
      isProgrammaticScroll = true;
      setActive(wrapped);

      // Compute the target scrollLeft directly from bounding boxes and scroll
      // the track itself, instead of relying on scrollIntoView: browsers are
      // inconsistent about which ancestor scrollIntoView picks when there are
      // nested scroll containers, and about honoring the `inline` option.
      var trackRect = track.getBoundingClientRect();
      var slideRect = slide.getBoundingClientRect();
      var slideOffsetInTrack = slideRect.left - trackRect.left + track.scrollLeft;
      var targetLeft;

      if (isDesktop()) {
        targetLeft = slideOffsetInTrack - (trackRect.width - slideRect.width) / 2;
      } else {
        var trackPaddingLeft = parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
        targetLeft = slideOffsetInTrack - trackPaddingLeft;
      }

      var maxScrollLeft = track.scrollWidth - track.clientWidth;
      targetLeft = Math.max(0, Math.min(targetLeft, maxScrollLeft));

      track.scrollTo({
        left: targetLeft,
        behavior: reducedMotion ? 'auto' : 'smooth',
      });
    }

    function goNext() {
      goToSlide(activeIndex + 1);
    }

    function goPrev() {
      goToSlide(activeIndex - 1);
    }

    function startAutoplay() {
      if (!autoplayEnabled || slides.length < 2 || autoplayTimer) return;
      autoplayTimer = window.setInterval(goNext, autoplayInterval);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    // Only trusted for native swipe/trackpad scrolling: any click-driven
    // navigation (arrow, dash, peek) already set the active slide directly
    // in goToSlide(), and is flagged via isProgrammaticScroll so it doesn't
    // get second-guessed by an intermediate slide crossing the threshold
    // mid-transition.
    var observer = new IntersectionObserver(
      function (entries) {
        if (isProgrammaticScroll) return;
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            var index = slides.indexOf(entry.target);
            if (index !== -1 && index !== activeIndex) {
              setActive(index);
            }
          }
        });
      },
      { root: track, threshold: [0.6] }
    );

    track.addEventListener('scroll', function () {
      if (scrollEndTimer) window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(function () {
        isProgrammaticScroll = false;
      }, 120);
    });

    slides.forEach(function (slide, index) {
      observer.observe(slide);
      slide.addEventListener('click', function () {
        if (index !== activeIndex) goToSlide(index);
      });
    });

    dashes.forEach(function (dash, index) {
      dash.addEventListener('click', function () {
        goToSlide(index);
      });
    });

    if (prevButton) prevButton.addEventListener('click', goPrev);
    if (nextButton) nextButton.addEventListener('click', goNext);

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('focusin', stopAutoplay);
    section.addEventListener('focusout', startAutoplay);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    setActive(0);
    startAutoplay();
  }

  function initAll() {
    var sections = document.querySelectorAll('.stories-carousel');
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  initAll();
  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
